import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/auth.store';

/**
 * Les écrans de dossier exigent une session du portail : sans elle, retour à
 * la connexion, qui ramène ici (`?suite=`, liste fermée de `lib/products.ts`).
 */
export function useSessionPortail() {
  const navigate = useNavigate();
  const { user, loading, fetchMe } = useAuthStore();

  useEffect(() => {
    void fetchMe();
  }, [fetchMe]);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      const suite = `${window.location.pathname}${window.location.search}`;
      navigate(`/login?suite=${encodeURIComponent(suite)}`, { replace: true });
    } else if (user.mfaRequired) {
      navigate('/double-authentification', { replace: true });
    }
  }, [loading, user, navigate]);

  return { user, pret: !loading && Boolean(user) && !user?.mfaRequired };
}
